import React from 'react';
import { SiReddit } from 'react-icons/si';

interface IconProps {
  color?: string;
  size?: number;
  width?: number;
  height?: number;
}

const RedditIcon: React.FC<IconProps> = ({ color = '#FF4500', size, width = 28, height = 28 }) => {
  const w = size || width;
  const h = size || height;
  
  return <SiReddit aria-hidden="true" color={color} width={w} height={h} />;
};

export default RedditIcon;
